<template>
    <div class="MessageListVueWrap">
      <ul v-if="messageArray.length > 0">
        <li v-for="item in messageArray" :key="item.id">
            <div class="top">
                <h4 :class=" item.status===1?'active':''" @click="openMessageBox(item)">{{ item.title }}</h4>
                <span @click="changeMessage(item)" :class=" item.status===1?'active':''">{{ item.status===2?'已读':'标为已读' }}</span>
            </div>
            <div class="bottom">
                <span class="type">系统消息</span>
                <span :class=" item.status===1?'active time':'time'">{{ item.createDate?item.createDate:'2024-05-05 12:00:00' }}</span>
            </div>
        </li>
      </ul>
      <el-empty v-else description="暂无消息"></el-empty>
    </div> 
  </template>
  
<script setup>
//   ref,
  import { defineProps,defineEmits } from 'vue';
  
  const { messageArray } = defineProps({
        messageArray: Array
    });

const emit = defineEmits(['openMessageBox','changeMessageStatus']);
const openMessageBox = (row) => {
    emit('openMessageBox', row)
}
const changeMessage = (row) => {
    if(row.status === 1) {
        emit('changeMessageStatus', row.id)
    }
}
</script>
  
<style lang="scss" scoped>
 .MessageListVueWrap {
    padding-top: 20px;
    ul {
        li {
            margin-bottom: 20px;
            padding-left: 30px;
            position: relative;
            list-style: none;

            &::after {
                content: ' ';
                height: 80%;
                width: 3px;
                position: absolute;
                background: #4095E5;
                top: 50%;
                left: 5px;
                transform: translateY(-50%);
            }

            .top {
                display: flex;
                align-items: center;
                justify-content: space-between;

                h4 {
                    flex: 1;
                    font-size: 14px;
                    min-height: 2.5em;
                    color: #999;
                    cursor: pointer;
                    &.active {
                        color: #000;
                    }
                }
                span {
                    font-size: 14px;
                    &.active {
                        cursor: pointer;
                        color: #4095E5;
                        font-weight: bold;
                    }
                }
            }

            .bottom {
                display: flex;
                align-items: center;
                justify-content: space-between;

                .type {
                    display: inline-block;
                    padding: 5px 15px;
                    border: 1px solid rgba(187,187,187,1);
                    border-radius: 5px;
                    font-size: 12px;
                    cursor: default;
                    
                }

                .time {
                    font-family: 'SourceHanSansSC-bold';
                    color: #999;
                    font-size: 12px;
                    &.active {
                        color: #000;
                        font-weight: bold;
                    }
                }
            }
        }
    }
 }
  </style>